import * as React from "react";

import ModalComponent from "./ModalComponent";

import '../../styles/Modal.css'
import '../../styles/Widget.css'
import TemplatesList from "../TemplatesList";
import RepoEntitiesList from "../RepoEntitiesList";

import iconClose from '../../../assets/icons/close.svg'
import StateGlobal from "../../StateGlobal";

export default class ModalEntitySelection extends ModalComponent
{
    constructor(props)
    {
        super(props);
        this.state = {
            openModal: false,
            selected: []
        };
        this.aRef = React.createRef();
    }

    setSelected = () =>
    {
        if (!this.aRef.current)
        {
            return;
        }
        const aSelected = this.aRef.current.getSelected();
        if (!aSelected)
        {
            this.state.selected = [];
            return;
        }
        this.state.selected = aSelected;
    }

    getSelected = () =>
    {
        return this.state.selected;
    }

    render()
    {
        const sContent = this.props.content;
        const sRejectLabel = this.props.rejectLabel;
        const sConfirmLabel = this.props.confirmLabel;
        const callback = this.props.callback;
        const aSelected = this.props.selected;

        return (
            this.state.openModal ?
                <div className="PopupBackground">
                    <div className="PopupContent PopupContent--extended">
                        <div className="popup__header">
                            <h1 className="popup__title"></h1>
                            <button className="popup__close-btn" onClick={()=>{
                                // StateGlobal._currentBradCrumbs.pop();
                                this.state.displayError = false;
                                this.toggleModal();
                            }}>
                                <img src={iconClose}/>
                            </button>
                        </div>
                        {
                            sContent === "templates" ?
                                <div>
                                    <TemplatesList
                                        ref={this.aRef}
                                        selected={aSelected}
                                    />
                                </div> :
                                null
                        }
                        {
                            sContent === "entities" ?
                                <div>
                                    <RepoEntitiesList
                                        ref={this.aRef}
                                        selected={aSelected}
                                    />
                                </div> :
                                null
                        }
                        <button className="wrcButton wrcButton--confirm" onClick={() =>
                        {
                            this.setSelected();

                            if (this.state.selected &&
                                (
                                    (Array.isArray(this.state.selected) && 0 < this.state.selected.length) ||
                                    (!Array.isArray(this.state.selected) && 0 < Object.keys(this.state.selected).length && Object.values(this.state.selected).find(aItem =>
                                    {
                                        return aItem && !(Array.isArray(aItem) && 0 >= aItem.length);
                                    }))
                                )
                            )
                            {
                                if (callback && "function" === typeof callback)
                                {
                                    callback();
                                }
                                this.toggleModal();
                            }
                        }}>
                            {sConfirmLabel}
                        </button>
                        <button className="wrcButton wrcButton--confirm" onClick={this.toggleModal}>
                            {sRejectLabel}
                        </button>
                    </div>
                </div> :
                null
        );
    }
}